import { get } from "lodash";

import {
  canCreateChild,
  isSupply,
  isDemand,
} from "src/util/directory-customerConfig";
import { hasAdminOrPowerRole } from "src/services/auth";

export const isRealTimeAllocationsEnabled = ({
  user,
  workspace,
  allocationProject,
}) => {
  return (
    hasAdminOrPowerRole(user) &&
    !get(workspace, "config.allocation.disableIndividualAllocation") &&
    (!!get(allocationProject, "enableRealtimeAllocation") ||
      !!get(workspace, "config.featureFlags.enableFutureAllocationsUI"))
  );
};

export const canAddNewTeam = (user, groupTypes, team) => {
  return hasAdminOrPowerRole(user) && canCreateChild(groupTypes, team);
};

export const canChangeSupplyGroup = (workspace) =>
  get(workspace, "config.allocation.enableChangeSupplyGroup", false);

/**
 * Returns true if the group type is a supply type (isSupply, isSupplyRoot, or isSupplySource).
 */
export const isSupplyType = (groupType) =>
  !!(
    groupType &&
    (groupType.isSupply || groupType.isSupplyRoot || groupType.isSupplySource)
  );

/**
 * Returns true if supply teams can be modified (add/move/remove) as children.
 * Checks root type(s): when any root has enableModifySupplyTeams === false, returns false.
 * Default true when undefined (backwards compatible).
 */
export const canModifySupplyTeams = (groupTypes) => {
  const types = groupTypes || {};
  const rootTypes = Object.values(types).filter((gt) => gt && gt.isRoot);
  if (rootTypes.length === 0) {
    return true;
  }
  return rootTypes.every((gt) => gt.enableModifySupplyTeams !== false);
};

/**
 * Returns the names of root types that have enableModifySupplyTeams === false.
 * Used for enforcement messages when supply team settings (renamable, can create child) are locked.
 */
export const getRootTypesWithSupplyModifyDisabled = (groupTypes) => {
  const types = groupTypes || {};
  return Object.values(types)
    .filter((gt) => gt && gt.isRoot && gt.enableModifySupplyTeams === false)
    .map((gt) => gt.name || gt.id);
};

export const isAddingMemberEnabled = (workspace, team) => {
  return (
    isDemand(get(workspace, "config.groupTypes"), team) ||
    (canChangeSupplyGroup(workspace) &&
      isSupply(get(workspace, "config.groupTypes"), team))
  );
};
